import {useDispatch, useSelector} from "react-redux";
import {rxShowTagEditor, selectAllTags} from "../../../../slices/tagsSlice";
import {useTranslation} from "react-i18next";

const useSettingsTags = () => {
  const dispatch = useDispatch();

  const {t} = useTranslation("settings_tags");

  const tags = useSelector(selectAllTags);

  const showTagEditor = (mode, tag) => dispatch(rxShowTagEditor({mode, tag}));

  return {
    t,
    tags,
    showTagEditor
  };
};

export default useSettingsTags;
